module.exports = __webpack_public_path__ + "static/og-image-5b98a9761a0563490d162bb3f8d4b9b1.png";